export default __webpack_public_path__ + "static/media/es-flag.cfb7f848.svg";